<template lang="pug">
div
  .modal-filbox.ss-filbox(:class="{'aaa' : showModal === true}")
    .modal-filbox-content
      .tt-main.text-uppercase {{$t('ui.slots')}}
      .filter-close.ss-filbox-close(@click="closeModal")
        img(src='/images/cancel-icon.png')
      .conbox
        .tt-item.text-capitalize {{$t('ui.provider')}}
        .filter-itembox.sgfilterbox
          span.sgfilter(:class="{'aaa' : providerSelected === 0 }" @click="changeProvider(0)")
            img(src='/images/provider/epic.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 1 }" @click="changeProvider(1)")
            img(src='/images/provider/mega.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 2 }" @click="changeProvider(2)")
            img(src='/images/provider/pragmatic.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 3 }" @click="changeProvider(3)")
            img(src='/images/provider/jili.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 4 }" @click="changeProvider(4)")
            img(src='/images/provider/live22.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 26 }" @click="changeProvider(26)")
            img(src='/images/provider/hacksaw.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 23 }" @click="changeProvider(23)")
            img(src='/images/provider/nlc.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 24 }" @click="changeProvider(24)")
            img(src='/images/provider/bng.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 5 }" @click="changeProvider(5)")
            img(src='/images/provider/spadegaming.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 6 }" @click="changeProvider(6)")
            img(src='/images/provider/joker.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 7 }" @click="changeProvider(7)")
            img(src='/images/provider/habanero.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 8 }" @click="changeProvider(8)")
            img(src='/images/provider/cq9.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 9 }" @click="changeProvider(9)")
            img(src='/images/provider/fc-gaming-w.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 10 }" @click="changeProvider(10)")
            img(src='/images/provider/jdb.png')
          span.sgfilter.position-relative(:class="{'aaa' : providerSelected === 11 }" @click="changeProvider(11)")
            img(src='/images/provider/jdb.png')
            .position-absolute.end-0 (GTF)
          span.sgfilter(:class="{'aaa' : providerSelected === 12 }" @click="changeProvider(12)")
            img(src='/images/provider/microgaming.png')
          //- span.sgfilter(:class="{'aaa' : providerSelected === 13 }" @click="changeProvider(13)")
            img(src='/images/provider/spinix.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 14 }" @click="changeProvider(14)")
            img(src='/images/provider/bgaming.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 15 }" @click="changeProvider(15)")
            img(src='/images/provider/yes-bingo.png')
          //- span.sgfilter(:class="{'aaa' : providerSelected === 16 }" @click="changeProvider(16)")
            img(src='/images/provider/hacksaw.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 17 }" @click="changeProvider(17)")
            img(src='/images/provider/relax-gaming.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 18 }" @click="changeProvider(18)")
            img(src='/images/provider/evoplay.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 19 }" @click="changeProvider(19)")
            img(src='/images/provider/playngo.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 20 }" @click="changeProvider(20)")
            img(src='/images/provider/netent.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 21 }" @click="changeProvider(21)")
            img(src='/images/provider/rt.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 22 }" @click="changeProvider(22)")
            img(src='/images/provider/btg.png')
          span.sgfilter(:class="{'aaa' : providerSelected === 25 }" @click="changeProvider(25)")
            img(src='/images/provider/advantplay.png')
          span.sgfilter(@click="$router.push('/partners').catch(err => {})")
            img(src='/images/provider/partner.png')
  template(v-if="showLobby")
    .dropdown-wrapper.mobile-game(:class="imgClass")
      a(href='javascript:void(0)' @click="selectOption(0)")
        .pvd-img
          img(src='/images/products/epicwin.png')
      a.hot-game(href='javascript:void(0)' @click="selectOption(1)")
        .pvd-img
          img(src='/images/products/megah5.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/MEGA888.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/918KISS.png')
      a.hot-game(href='javascript:void(0)' @click="selectOption(2)")
        .pvd-img
          img(src='/images/products/pragmatic.png')
      a.hot-game(href='javascript:void(0)' @click="selectOption(3)")
        .pvd-img
          img(src='/images/products/jili.png')
      a(href='javascript:void(0)' @click="selectOption(4)")
        .pvd-img
          img(src='/images/products/live22.png')
      a(href='javascript:void(0)' @click="selectOption(5)")
        .pvd-img
          img(src='/images/products/spade.png')
      a(href='javascript:void(0)' @click="selectOption(6)")
        .pvd-img
          img(src='/images/products/joker.png')
      a(href='javascript:void(0)' @click="selectOption(7)")
        .pvd-img
          img(src='/images/products/habanero.png')
      a(href='javascript:void(0)' @click="selectOption(8)")
        .pvd-img
          img(src='/images/products/cq9.png')
      a(href='javascript:void(0)' @click="selectOption(9)")
        .pvd-img
          img(src='/images/products/fachai.png')
      a(href='javascript:void(0)' @click="selectOption(10)")
        .pvd-img
          img(src='/images/products/jdb.png')
      a(href='javascript:void(0)' @click="selectOption(11)")
        .pvd-img
          img(src='/images/products/jdb-gtf.png')
      a(href='javascript:void(0)' @click="selectOption(12)")
        .pvd-img
          img(src='/images/products/microgaming.png')
      a(href='javascript:void(0)' @click="selectOption(26)")
        .pvd-img
          img(src='/images/products/hacksaw.png')
      a(href='javascript:void(0)' @click="selectOption(23)")
        .pvd-img
          img(src='/images/products/nolimit.png')
      a(href='javascript:void(0)' @click="selectOption(24)")
        .pvd-img
          img(src='/images/products/bng.png')
      //- a(href='javascript:void(0)' @click="selectOption(13)")
        .pvd-img
          img(src='/images/products/spinix.png')
      a(href='javascript:void(0)' @click="selectOption(14)")
        .pvd-img
          img(src='/images/products/bgaming.png')
      a(href='javascript:void(0)' @click="selectOption(15)")
        .pvd-img
          img(src='/images/products/yesbingo.png')
      a(href='javascript:void(0)' @click="selectOption(17)")
        .pvd-img
          img(src='/images/products/relax.png')
      a(href='javascript:void(0)' @click="selectOption(18)")
        .pvd-img
          img(src='/images/products/evoplay.png')
      a(href='javascript:void(0)' @click="selectOption(19)")
        .pvd-img
          img(src='/images/products/png.png')
      a(href='javascript:void(0)' @click="selectOption(20)")
        .pvd-img
          img(src='/images/products/netent.png')
      a(href='javascript:void(0)' @click="selectOption(21)")
        .pvd-img
          img(src='/images/products/redtiger.png')
      a(href='javascript:void(0)' @click="selectOption(22)")
        .pvd-img
          img(src='/images/products/btg.png')
      a(href='javascript:void(0)' @click="selectOption(25)")
        .pvd-img
          img(src='/images/products/advant-play.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/918kaya.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/ACE333.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/AGPARTNER.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/betsoft.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/dragonsoft.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/dreamtech.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/FG.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/funky.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/gameplay.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/mario.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/nextspin.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/pegasus.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/playstar.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/playtech.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/pussy888.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/suncity.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/uuslot.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/vpower.png')
      router-link(to="/partners")
        .pvd-img
          img(src='/images/partners/xe88.png')
  template(v-else)
    .gbox-wrap.slot-lobby
      .gbox-menu-wrap-add
        //- .gbox-menu-fav
          a.s-fav.epw-fav-btn(href="javascript:void(0)")
            img(src="/images/fav.png")
        .gbox-menu-fav.pointer(style="font-size: 16px;width:170px;" @click="backLobby")
          i.fa-solid.fa-circle-chevron-left.me-2
          div.text-uppercase &nbsp;All Slots
        .gbox-menu-wrap
          .gbox-filbox.ss-filter(@click="showProvider")
            .nname {{getProvider}}
            .iicon
              img(src='/images/dropdown-icon.png')
          .gbox-search.ss-search 
            .iicon 
              img(src="/images/search-icon.png")
      .gbox-search-box.ss-search-box(:class="{'aaa': showSearch}")
        .search-games
          input.form-control(type='text' v-model="searchinput" :placeholder="$t('ui.search')")
        span.search-cancel.ss-search-cancel.pointer(@click="cancelSearch")
          i.fa-solid.fa-circle-xmark
      //- epicGame(v-if="providerSelected === 0")
      epic2(v-if="providerSelected === 0" :searchinput="searchinput")
      megaH5(v-if="providerSelected === 1" :searchinput="searchinput")
      pragmatic(v-if="providerSelected === 2" :searchinput="searchinput")
      jili(v-if="providerSelected === 3" :searchinput="searchinput")
      live22(v-if="providerSelected === 4" :searchinput="searchinput")
      sgGame(v-if="providerSelected === 5" :searchinput="searchinput")
      joker(v-if="providerSelected === 6" :searchinput="searchinput")
      hbGame(v-if="providerSelected === 7" :searchinput="searchinput")
      cq9(v-if="providerSelected === 8" :searchinput="searchinput")
      fc(v-if="providerSelected === 9" :searchinput="searchinput")
      jdb(v-if="providerSelected === 10" :searchinput="searchinput")
      jdbGtf(v-if="providerSelected === 11" :searchinput="searchinput")
      microgaming(v-if="providerSelected === 12" :searchinput="searchinput")
      //- spinix(v-if="providerSelected === 13" :searchinput="searchinput")
      bgaming(v-if="providerSelected === 14" :searchinput="searchinput")
      yesbingo(v-if="providerSelected === 15" :searchinput="searchinput")
      //- hacksawgaming(v-if="providerSelected === 16")
      relaxgaming(v-if="providerSelected === 17" :searchinput="searchinput")
      evoplay(v-if="providerSelected === 18" :searchinput="searchinput")
      playngo(v-if="providerSelected === 19" :searchinput="searchinput")
      netent(v-if="providerSelected === 20" :searchinput="searchinput")
      evort(v-if="providerSelected === 21" :searchinput="searchinput")
      btg(v-if="providerSelected === 22" :searchinput="searchinput")
      nlc(v-if="providerSelected === 23" :searchinput="searchinput")
      bng(v-if="providerSelected === 24" :searchinput="searchinput")
      advantplay(v-if="providerSelected === 25" :searchinput="searchinput")
      hacksawdirect(v-if="providerSelected === 26" :searchinput="searchinput")
</template>
<script>
import epic2 from '@/components2/slot/_epic2.vue'
import live22 from '@/components2/slot/_live22.vue'
import hbGame from '@/components2/slot/_habanero.vue'
import sgGame from '@/components2/slot/_spadeGaming.vue'
import pragmatic from '@/components2/slot/_pragmatic.vue'
import joker from '@/components2/slot/_joker.vue'
import megaH5 from '@/components2/slot/_megaH5.vue'
import cq9 from '@/components2/slot/_cq9.vue'
import jili from '@/components2/slot/_jili.vue'
import fc from '@/components2/slot/oneapi/_fc.vue'
import jdb from '@/components2/slot/oneapi/_jdb.vue'
import jdbGtf from '@/components2/slot/oneapi/_jdbGtf.vue'
import microgaming from '@/components2/slot/oneapi/_microgaming.vue'
// import spinix from '@/components2/slot/oneapi/_spinix.vue'
import bgaming from '@/components2/slot/oneapi/_bgaming.vue'
import yesbingo from '@/components2/slot/oneapi/_yesbingo.vue'
// import hacksawgaming from '@/components2/slot/oneapi/_hacksawgaming.vue'
import relaxgaming from '@/components2/slot/oneapi/_relaxgaming.vue'
import evoplay from '@/components2/slot/oneapi/_evoplay.vue'
import playngo from '@/components2/slot/oneapi/_playngo.vue'
import netent from '@/components2/slot/oneapi/_evontt.vue'
import evort from '@/components2/slot/oneapi/_evort.vue'
import btg from '@/components2/slot/oneapi/_evobtg.vue'
import nlc from '@/components2/slot/oneapi/_evonlc.vue'
import bng from '@/components2/slot/oneapi/_bng.vue'
import advantplay from '@/components2/slot/oneapi/_advantplay.vue'
import hacksawdirect from '@/components2/slot/oneapi/_hacksawdirect.vue'
export default{
  components:{
    // epicGame,
    epic2,
		hbGame,
		sgGame,
		// pgsGame,
		pragmatic,
		joker,
		live22,
    megaH5,
    cq9,
    jili,
    fc,
    jdb,
    jdbGtf,
    microgaming,
    // spinix,
    bgaming,
    yesbingo,
    // hacksawgaming,
    relaxgaming,
    evoplay,
    playngo,
    netent,
    evort,
    btg,
    nlc,
    bng,
    advantplay,
    hacksawdirect
  },
  props: {
    imgClass: {
      type: String,
      default: ""
    },
  },
  data(){
    return{
      providerSelected: 0,
      showLobby:true,
      showModal:false,
      providerList:[
				"EpicWin",
				"Mega",
				"Pragmatic",
				"JILI",
				"LIVE22",
        "Spade",
        "Joker",
        "Habanero",
        "CQ9",
        "FACHAI",
        "JDB",
        "JDB X GTF",
        "Microgaming+",
        "Spinix",
        "Bgaming",
        "Yesbingo",
        "Hacksaw Gaming",
        "Relax Gaming",
        "Evoplay",
        "PlaynGo",
        "Netent",
        "RT",
        "BTG",
        "NLC",
        "BNG",
        "Advantplay",
        "Hacksaw Direct"
			],
      showSearch: false,
      searchinput:"",
    }
  },
  computed:{
    getProvider(){
			return this.providerList[this.providerSelected]
		},
  },
  mounted(){
    window.scroll(0,0)
    if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.custom == true){
				this.selectOption(this.$route.params.target)
			}
    }
  },
  methods:{
    backLobby(){
      this.showLobby = true
    },
    showProvider(){
			this.showModal = true
      // $('.modal-filbox').addClass('aaa')
			$('body').addClass('noscroll')
		},
    closeModal(){
      this.showModal = false
      $('body').removeClass('noscroll')
    },
    selectOption(target){
      this.showLobby = false
      window.scroll(0, 0)
      // this.$store.dispatch("user/setSlotSelected", target)
      this.providerSelected = target
    },
    changeProvider(option){
			if(option !== this.providerSelected){
				this.providerSelected = option
			}
			this.showModal = false
			$('body').removeClass('noscroll')
			this.showFav = false
		},
    cancelSearch(){
			this.showSearch = false
			this.searchinput = ""
		},
  }
}
</script>